import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CodeBlock from "../CodeBlock.tsx";
import SectionCard from "../SectionCard.tsx";

type Json = Record<string, unknown> | null | undefined;

interface SourceDataProps {
  data: Json;
  title?: string;
}

function hasData(data: Json): data is Record<string, unknown> {
  return !!data && Object.keys(data).length > 0;
}

/** A record's raw source payload as a JSON card; nothing when empty. */
export default function SourceDataCard({ data, title = "Source Data" }: SourceDataProps) {
  if (!hasData(data)) return null;
  return (
    <SectionCard title={title}>
      <CodeBlock>{JSON.stringify(data, null, 2)}</CodeBlock>
    </SectionCard>
  );
}

/** The same JSON inline, for an expanded table row. */
export function SourceDataBlock({ data, title = "Source Data" }: SourceDataProps) {
  if (!hasData(data)) return null;
  return (
    <Box sx={{ mt: 1 }}>
      <Typography variant="subtitle2" gutterBottom>
        {title}
      </Typography>
      <CodeBlock maxHeight={400}>{JSON.stringify(data, null, 2)}</CodeBlock>
    </Box>
  );
}
